<app-access-window [termsConditions]="termsConditions"
                   [paymentCardsListControls]="paymentCardsListControls"
                   [loading]="loadingService.loading | async"
                   (proceedPayment$)="payForSlot($event)"
></app-access-window>
